import { IIncidentFilter, IIncidentsPageFilterField } from '../interfaces/incidents-page-filter';

export class IncidentPageTabState {
  get filter(): IIncidentFilter {
    return this._filter;
  }

  private _filter: IIncidentFilter;

  constructor(private _opened: boolean) {
    this.init();
  }

  init() {
    let filters: IIncidentsPageFilterField = { opened: this._opened };
    if (this._opened) {
      filters.assignedToMe = { value: false };
      filters.regNo = {};
      filters.customerIdList = {};
      filters.supplierIdList = {};
      filters.incidentType = {};
      filters.completedTo = {};
      filters.completedFrom = {};
    } else {
      filters.openedFrom = {};
      filters.openedTo = {};
      filters.closedFrom = {};
      filters.closedTo = {};
      filters.assignees = {};
      filters.incidentType = {};
    }

    this._filter = {
      first: 0,
      rows: 20,
      sortField: '',
      sortOrder: 1,
      filters: filters,
    };
  }
}
